import {useCallback, useEffect, useState} from 'react';

const pages = ['review', 'add'] as const;

export type PageTypes = (typeof pages)[number];

const isAddUrl = (url) => url.includes('#add');

const usePageHooks = () => {
  const [currentPage, setPage] = useState<PageTypes>(pages[0]);

  // handler for adding pages, only push state when
  const setCurrentPage = useCallback(
    (newPage: PageTypes) => {
      if (newPage === 'add') {
        window.location.hash = 'add';
        setPage('add');
      } else if (newPage === 'review') {
        setPage('review');
        window.history.back();
      }
    },
    [currentPage, setPage]
  );

  // remove any hashes on mount
  useEffect(() => {
    window.location.hash = '';
    window.history.replaceState('', '', window.location.pathname); // remove any hash on mount
  }, []);

  /**
   * handler for hashchange event
   * meant to change page when using back/next button on web nav
   */

  const handleHashChange = useCallback(
    (e) => {
      const {oldURL, newURL} = e;
      if (currentPage === 'add') {
        // url changed to review but currentPage val has not
        if (!isAddUrl(newURL) && isAddUrl(oldURL)) {
          setPage('review');
        }
      }
      if (currentPage === 'review') {
        // url changed to add but currentPage val has not
        if (isAddUrl(newURL) && !isAddUrl(oldURL)) {
          setPage('add');
        }
      }
    },
    [currentPage, setCurrentPage]
  );

  const resetPageHook = () => {
    setPage('review');
    window.history.replaceState('', '', window.location.pathname); // remove any hashes
  };

  return {
    currentPage,
    setCurrentPage,
    resetPageHook,
    handleHashChange
  };
};

export default usePageHooks;
